import * as Handlebars from 'handlebars/runtime';
import deviceTypeIcon from 'templates/partials/deviceTypeIcon';
import navbar from 'templates/partials/navbar';
Handlebars.registerHelper({});
Handlebars.registerPartial({deviceTypeIcon,navbar});
export default Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<span class=\"deviceContainer\"></span>\n<button id=\"selectDeviceButton\" class=\"btn btn-light\"><i class=\"far fa-plus-square\"></i> Add Device</button>\n";
},"useData":true});